import {h, Fragment, Component} from "preact";
import { Trans } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

import PFeed from "../../../services/prematch-feed";
import Page from "../../../services/page-data-feed";

import SchedulesTimeFilter from "../utils/schedules-time-filter";

import * as M from "../desktop-templates/prematch-menu.jsx";

export default class MenuFull extends Component {
	state = {
		sports: null
	}
	componentWillMount() {
		PFeed.getMenu((label, menu) => {
			this.setState({
				sports: Object.values(menu).sort((a, b) =>a.order - b.order)
			})
		})
	}
	render({onTournamentOpen}) {
		if (this.state.sports == null)
			return null;
		return <div class="rounded-xl overflow-hidden mt-3">
			{this.state.sports
				.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
				.map(sport => <SportRow key={sport.id} sport={sport} onTournamentOpen={onTournamentOpen} />)}
		</div>
	}
}

export class SportRow extends Component {
	state = {
		open: false,
		wasOpen: false,
		checked: []
	};
	componentWillMount() {
		this.setState({
			open: this.props.open,
			wasOpen: this.props.open,
			checked: Object.values(this.props.sport.sub).map(() => false) // Proseguire dalle checkbox
		})
	}
	render({sport, onTournamentOpen}) {
		return <div>
			<M.SportButton active={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
				{/*<M.CircleSeparator />*/}
			  <M.SportFlagIcon sport={sport} />
			  <M.LeagueNameLabel>{sport.name}</M.LeagueNameLabel>
			  <M.MenuMatchCounter>{sport.count}</M.MenuMatchCounter>
			</M.SportButton>
			{this.state.wasOpen && <div class={this.state.open ? "" : "hidden"}>
				{Object.values(sport.sub)
					.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
					.sort((a, b) => {
						if (!a.order) {
							a.order = 100000000;
						}
						if (!b.order) {
							b.order = 100000000;
						}
						if (a.order !== b.order) {
							return a.order - b.order
						}
						if (a.name < b.name) {
							return -1;
						}
						if (a.name > b.name) {
							return 1;
						}
						return 0;
					}).map(category => {
						return <CategoryRow key={category.id} category={category} onTournamentOpen={onTournamentOpen} />
					})
				}
			</div>}
		  </div>
	}
}

export class CategoryRow extends Component {
	state = {
		open: false,
		wasOpen: false,
		checked: []
	};
	componentWillMount() {
		this.setState({
			open: this.props.open,
			wasOpen: this.props.open,
			checked: Object.values(this.props.category.sub).map(() => false) // Proseguire dalle checkbox
		})
	}
	render({category, onTournamentOpen}) {
		return <div>
		  <M.CategoryButton active={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
			<M.CircleSeparatorW2 />
			<M.RegionFlag category={category} />
			<M.LeagueNameLabel>{category.name}</M.LeagueNameLabel>
			<M.ToggleCartet active={this.state.open} />
		  </M.CategoryButton>
		  {this.state.wasOpen && <div class={this.state.open ? "" : "hidden"}>
		    {Object.values(category.sub)
				.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
				.sort((a, b) => a.order - b.order)
				.map(tournament => (
				<TournamentRow key={tournament.id} tournament={tournament} onTournamentOpen={onTournamentOpen} />
			))}
		  </div>}
		</div>
	}
}

function TournamentRow({tournament, onTournamentOpen}) {
	const isOpen = Page.tournamentIsOpen(tournament.id);
	return <M.TournamentButton 
		   active={isOpen} 
		   onClick={e => {
			   if (isOpen)
				   Page.closeTournament(tournament.id)
			   else
				   Page.openTournaments([tournament.id])
			   if (!!onTournamentOpen)
				   onTournamentOpen(tournament);
		   }}
	   >
	  <M.CircleSeparatorW3 active={isOpen} />
	  <M.TournamentLabel>{tournament.name}</M.TournamentLabel>
	  <M.TournamentPlusSign active={isOpen} />
	</M.TournamentButton>
}